import React, { useEffect, useState, useMemo } from "react";
import { Page } from "components/common";
import { Button, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalHeader, UncontrolledDropdown } from "reactstrap";
import BackButton from "components/refactoring/BackButton";
import { Trans } from "react-i18next";
import { Control, LocalForm } from "react-redux-form";
import { FormGroup } from "components/common";
import csv_icon from "assets/images/csv-svgrepo-com.svg";
import create_icon from "assets/images/plus-svgrepo-com.svg";
import excel_icon from "assets/images/file-excel-svgrepo-com.svg";
import list_icon from "assets/images/bulleted-list-svgrepo-com.svg";
import persons_icon from "assets/images/persons.svg";
import date_icon from "assets/images/date_time.svg";
import created_by_icon from "assets/images/created_by.svg";
import { useOrganisationContext } from "hooks";
import { ApiClient, } from "services";
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom";
import { customDateFormat } from "services/util";
import useModal from "hooks/useModal";
import { getColorsForStages } from "services/util";
import { useBaseModal } from "services";

export const Lists = ({ t }) => {
    const [trackingLists, setTrackingLists] = useState([]);
    const [dataForListEdit, setDataForListEdit] = useState({});
    const history = useHistory();

    const { Modal: UpdateListModal, toggle: toggleUpdate, isOpen: isUpdateOpen } = useModal();
    const { Modal: DeleteListModal, toggle: toggleDelete, isOpen: isDeleteOpen } = useModal();
    const [SetCreateUpdateListModal, CreateUpdateListToggle, CreateUpdateListModal] = useBaseModal();

    useEffect(() => {
        getLists();
    }, []);

    const [selectedColor, setSelectedColor] = useState('');

    const colors_for_stages = useMemo(() => getColorsForStages(), []);

    const { selectedOrganisation } = useOrganisationContext();
    const client = ApiClient();

    const getLists = async () => {
        const lists = await client.get(`streak-list/${selectedOrganisation.id}/tracking-list`).get("data");
        setTrackingLists(lists);
        return lists;
    };

    const handleSubmit = (values) => {
        let method = 'post';
        let url = `streak-list/${selectedOrganisation.id}/tracking-list`;
        let payload = { ...values, color_class: selectedColor };
        if (dataForListEdit?.id) {
            method = 'put';
            url = `${url}/${dataForListEdit?.id}`;
        } else {
            method = 'post';
        }
        client[method](url, payload)
            .then((data) => {
                NotificationManager.success(t("Saved successfully"));
                getLists();
                CreateUpdateListToggle();
                setDataForListEdit({});
            })
            .catch(error => {
                    NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
            })
        };

    const listDetail = (id) => {
        history.push(`/tracking-lists/detail/${id}/`);
    };

    const handleEditList = (e, details) => {
        e.stopPropagation()
        setDataForListEdit(details);
        if (!selectedColor) {
            setSelectedColor(dataForListEdit?.color_class);
        };
        CreateUpdateListToggle();
    };

    const handleDeleteListClick = (e, list) => {
        toggleDelete();
        setDataForListEdit(list);
    };

    const handleDeleteList = async (e, list) => {
        try {
            const response = await client.delete(`streak-list/${selectedOrganisation.id}/tracking-list/${list?.id}`)
            getLists();
            NotificationManager.success(t("List deleted successfully"));
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                NotificationManager.error(error.response.data.error);
            } else {
                NotificationManager.error(t("Something went wrong. Please try again."));
            }
        }
        toggleDelete();
    };

    return (
        <>
            <Page title={t(`Lists`)}>
                <BackButton />
                <div>
                    <Button color="primary" className="ml-2" onClick={() => {setDataForListEdit({});CreateUpdateListToggle();}}><i className="fa fa-plus mr-2"></i><Trans>New List</Trans></Button>
                </div>
                <div className="row justify-content-start mt-4 mx-1">
                    {trackingLists.map((list) => (
                        <div className="col-lg-4 col-xl-3 col-md-3 col-sm-6 p-2">
                            <div
                                className={`border rounded shadow-sm p-2 clickable mb-3`}
                                role="button"
                                onClick={() => listDetail(list?.id)}
                            >
                                <div className="mt-2 ">
                                    <div className={`${list.color_class} text-left text-weight-bold w-100 text-truncate`}>
                                        <span className="p-2">
                                            <Trans>{list.name}</Trans>
                                        </span>
                                    </div>
                                    <div className={`mt-2`}>
                                        <img src={date_icon} height={20} alt="list_icon" /><span className="ml-1">{customDateFormat(list.created_at, "MMMM Do YYYY, h:mma")}</span>
                                    </div>
                                    <div className={`mt-2`}>
                                        <img src={persons_icon} height={20} alt="list_icon" /><span className="ml-1">{list?.employees?.length}</span>
                                    </div>
                                    <div className={`mt-2 small`}>
                                        <img src={created_by_icon} height={20} alt="list_icon" /><span className="ml-1">{list?.created_by?.full_name}</span>
                                    </div>
                                    <div className="row" onClick={(e) => e.stopPropagation()}>
                                        <div className="w-100 row justify-content-center p-0 border-bottom-0 mt-1">

                                            <UncontrolledDropdown
                                                direction="down"
                                            >
                                                <DropdownToggle
                                                    className="bg-transparent border-0 shadow-none btn-link mb-0 three-dots p-0 text-dark"
                                                >
                                                    <i class="fas fa-ellipsis-h"></i>
                                                </DropdownToggle>
                                                <DropdownMenu className="p-0">
                                                    <DropdownItem onClick={(e) => handleEditList(e, list)}>
                                                        <Trans>Edit</Trans>
                                                    </DropdownItem>
                                                    <DropdownItem onClick={(e) => handleDeleteListClick(e, list)}>
                                                        <Trans>Delete</Trans>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    ))}

                </div>
            </Page>

     
                <CreateUpdateListModal size="lg" title={t(`${dataForListEdit?.id ? "Update" : "Create"} List`)}>
                    <ModalBody>
                        <div className="row justify-content-center">
                            <LocalForm
                                className="col-12 col-md-10"
                                onSubmit={(values) => handleSubmit(values)}
                                initialState={dataForListEdit}
                            >
                                <FormGroup className="mb-2">
                                    <label htmlFor="name" className="form-label"><Trans>Name*</Trans></label>
                                    <Control.text
                                        model=".name"
                                        id="name"
                                        className="form-control"
                                        placeholder={t("Enter name")}
                                        required
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2">
                                    <label htmlFor="description" className="form-label"><Trans>Description</Trans></label>
                                    <Control.textarea
                                        model=".description"
                                        id="description"
                                        className="form-control"
                                        placeholder={t("Enter description")}
                                        rows={3}
                                    />
                                </FormGroup>

                                <FormGroup className="mb-2">
                                    <div
                                        className="justify-content-start flex-wrap d-flex"
                                        style={{
                                            gap: '10px',
                                        }}
                                    >
                                        {colors_for_stages.map((colorClass, index) => (
                                            <div
                                                key={index}
                                                className={`list-color color-circle ${colorClass} clickable ${dataForListEdit.color_class === colorClass ? 'border border-primary' : selectedColor === colorClass ? 'border border-primary' : dataForListEdit.color_class === colorClass}`}
                                                onClick={() => setSelectedColor(colorClass)}
                                            />
                                        ))}
                                    </div>
                                </FormGroup>

                                <FormGroup className="pl-4">
                                    <div className="d-flex justify-content-center mt-2 float-right">
                                        <Button color="secondary" onClick={() => SetCreateUpdateListModal()}>
                                            <Trans>Close</Trans>
                                        </Button>
                                        <Button color="primary" type="submit">
                                            {dataForListEdit?.id ? <Trans>Update</Trans> : <Trans>Create</Trans>}
                                        </Button>
                                    </div>
                                </FormGroup>
                            </LocalForm>
                        </div>
                    </ModalBody>
                </CreateUpdateListModal>


            {dataForListEdit && isDeleteOpen && (
                <DeleteListModal>
                    <ModalHeader toggle={toggleUpdate}>
                        <Trans>Delete list</Trans>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row justify-content-center">
                            <LocalForm
                                className="col-12 col-md-10"
                            >
                                <span><Trans>Are you sure you want to delete this list?</Trans></span>

                                <FormGroup className="pl-4">
                                    <div className="d-flex justify-content-center mt-2 float-right">
                                        <Button color="secondary" onClick={toggleDelete}>
                                            <Trans>Close</Trans>
                                        </Button>
                                        <Button color="primary" type="submit" onClick={(e) => handleDeleteList(e, dataForListEdit)}>
                                            <Trans>Delete</Trans>
                                        </Button>
                                    </div>
                                </FormGroup>
                            </LocalForm>
                        </div>
                    </ModalBody>
                </DeleteListModal>
            )}
        </>
    );
};

export default Lists;
